import React from "react";
import Modal from "../../styles/Modals";
import useQuery from "../../hooks/useQuery";
// import {useHistory} from "react-router-dom";
import styled from "styled-components";
import Color from "../../assets/Colors";

export default function PrivacyView() {
   let query = useQuery();
   const isOpen = query.get("privacy") === "true" ? true : false;
   // let history = useHistory();

   if (!isOpen) return null;

   return (
      <Modal back="rgba(255,255,255,0.95)">
         <>
            <TitleStyled>Política de Privacidad </TitleStyled>
            <SubtitleStyled>1. Introducción</SubtitleStyled>
            <TextStyled>
               Esta Política de Privacidad explica lo que hacemos con tus datos personales para prestar los servicios ofrecidos en la web
               www.domestika.org (la "Plataforma"), como la venta y suscripción a cursos, la creación de tu perfil en Domestika.org, la
               capacidad de ofrecer puestos de trabajo y postularse a ellos, comunicaciones, etc. (los "Servicios"). Esta política también
               explica los datos que podemos recopilar cuando visitas la Plataforma.
               <br />
               <br />
               De acuerdo con la legislación de datos aplicable, ten en cuenta lo siguiente:
               <br />
               <br />
               Si vives en un país miembro del Espacio Económico Europeo, esta Política de Privacidad y la forma de procesar tus datos
               estarán reguladas por el Reglamento General de Protección de Datos, o Reglamento [UE] 2016/679 ("RGPD").
               <br />
               <br />
               Si vives en un país que no forma parte del Espacio Económico Europeo, el procesamiento de tus datos personales estará
               regulado por las leyes de privacidad del Estado de California.
               <br />
               <br />
               La empresa responsable de los datos personales es Domestika Inc., con domicilio fiscal en 2325 3rd Street, Suite 215 San
               Francisco, CA, 94107, Estados Unidos (DOMESTIKA) ("Nosotros" o "Controlador de datos"). Puedes ponerte en contacto con el
               representante del Controlador de datos enviando un e-mail a: dataprotection@domestika.org
               <br />
               <br />
               En el caso de que no proporciones la información indicada como obligatoria, es posible que no podamos procesar tu registro de
               usuario o proporcionarte el uso de algunos Servicios que se encuentran disponibles en la Plataforma.
               <br />
               <br />
               Para poder registrarte y navegar por la Plataforma, es necesario que seas mayor de 16 años. DOMESTIKA puede utilizar tu
               información personal para verificar tu edad y asegurar el cumplimiento de esta restricción.
            </TextStyled>

            <SubtitleStyled>2. Base legal para el procesamiento de los datos personales</SubtitleStyled>
            <TextStyled>
               La recopilación y el procesamiento de tus datos personales se basa principalmente en la relación contractual y no contractual
               que tienes con nosotros.
               <br />
               <br />
               Cuando te enviamos boletines informativos y Servicios o cuando utilizamos la dirección de e-mail que nos has proporcionado
               para ponernos en contacto contigo de forma individual o para reconocerte cuando vuelves a visitar nuestra página web, lo
               hacemos bajo consentimiento informado.
               <br />
               <br />
               La manera en que procesamos la información recopilada por nuestras cookies se basa en el consentimiento informado que nos has
               dado, de acuerdo con la legislación vigente.
            </TextStyled>

            <SubtitleStyled>3. Información personal que recopilamos</SubtitleStyled>
            <TextStyled>
               Para registrarte en la Plataforma e identificarte, te pediremos tu dirección de e-mail y tu fecha de nacimiento.
               <br />
               <br />
               Para crear tu perfil en la Plataforma, puedes incluir información personal como el país o la ciudad en la que resides, una
               fotografía, tu nombre y tus apellidos, tu formación, tu experiencia profesional y cualquier otro dato que quieras compartir
               en tu perfil. La información del perfil te ayuda a aprovechar al máximo nuestros Servicios, como que te puedan encontrar
               otros profesionales y descubrir oportunidades de negocio o proyectos en los que estés interesado. Sin embargo, si no quieres
               que esta información sea pública, será suficiente con no rellenar tu perfil o borrar la información que hayas proporcionado.
               <br />
               <br />
               Para comprar o suscribirte a nuestros cursos, te pediremos información de tu tarjeta de crédito o débito, incluidos la fecha
               de validez y el código CVV. Si deseas pagar a través de PayPal, te pediremos la dirección de e-mail que tengas asociada a tu
               cuenta. Si deseas pagar con PayU, serás redirigido a la plataforma de pago. Si solicitas una factura, te pediremos tus datos
               de facturación si fuera necesario.
               <br />
               <br />
               Cuando visitas o utilizas nuestros Servicios, registramos datos como la frecuencia de uso, la fecha y la hora en las que
               accedes, cuándo ves o haces clic en un contenido específico, tus preferencias de cursos, los proyectos que compartes o el
               contenido que publicas. Utilizamos esa información cuando inicias sesión y cuando lees nuestros e-mails, y utilizamos las
               direcciones de protocolos de internet ("IP") para identificarte y registrar el uso que haces de la Plataforma
               <br />
               <br />
               No tomamos decisiones en función de los perfiles, más allá de la personalización de la publicidad y para la legítima
               prevención del fraude en internet.
               <br />
               <br />
               Obtenemos información a través de otras plataformas, por ejemplo, cuando te registras a través de Facebook o plataformas
               similares. Esto podría incluir textos o imágenes personales que estén disponibles en un sitio web externo.
            </TextStyled>

            <SubtitleStyled>4. Objetivo del procesamiento</SubtitleStyled>
            <TextStyled>
               DA, como Controlador de datos, procesará tus datos personales con los siguientes objetivos:
               <br />
               <br />
               Gestionar tu registro como usuario de la Plataforma, para identificarte y darte acceso a los Servicios que hay disponibles
               para los usuarios registrados en ella.
               <br />
               <br />
               El desarrollo, el cumplimiento y la ejecución del contrato para la provisión de servicios como la venta o suscripción a los
               cursos de Domestika PRO o de cualquier otro contrato que podamos tener en la Plataforma. Deberás tener en cuenta que:
               <br />
               <br />
               Nos autorizas de manera expresa a procesar los datos requeridos para la activación y el proceso de pago. Los códigos de
               seguridad de las tarjetas (CVV o CVC) solo se utilizarán para procesar la compra en curso como parte de tu información de
               pago y no se almacenarán ni serán procesados con posterioridad. El consentimiento para la activación de este recurso permite
               que tus datos se rellenen de forma automática en futuras compras, de modo que no tendrás que volver a introducir la
               información de pago cada vez que realizas una compra. Se entenderá que los datos introducidos serán válidos y estarán
               actualizados en futuras compras. Podrás modificar o borrar tus tarjetas de crédito o tu cuenta de PayPal en cualquier momento
               a través del método de pago del formulario de compra o a través de la configuración del método de pago de tu suscripción a
               Domestika PRO. Almacenamos y revelamos información de las tarjetas de acuerdo con los estándares de seguridad y
               confidencialidad internacionales para las tarjetas de crédito y débito. Por razones de seguridad, el uso de este recurso
               podría requerir cambios en tu contraseña. Recuerda que la seguridad de la Plataforma también depende del correcto uso y
               almacenamiento de las contraseñas confidenciales.
               <br />
               <br />
               Recomendar trabajos que coincidan con tu perfil.
               <br />
               <br />
               Ponernos en contacto contigo por e-mail para actualizarte e informarte sobre recursos, productos o servicios contratados,
               incluidas las actualizaciones de seguridad de la Plataforma, siempre que sea necesario y razonable.
               <br />
               <br />
               Responder a peticiones o consultas que hagas a través de los canales de atención al cliente disponibles en nuestra
               Plataforma.
               <br />
               <br />
               También utilizamos tu información para generar datos globales no identificables. Por ejemplo, para generar estadísticas sobre
               nuestros usuarios, sus trabajos o áreas de experiencia, el número de impactos o clics en un curso o proyecto determinado, o
               su demografía.
            </TextStyled>

            <SubtitleStyled>5. Opciones</SubtitleStyled>
            <TextStyled>
               La provisión del Servicio de Domestika puede conllevar el uso de tus datos personales, con tu consentimiento expreso, para
               hacerte llegar publicidad personalizada relacionada con nuestros productos y servicios, a través de e-mails u otros medios de
               comunicación electrónica, enviada por nosotros o por colaboradores externos. Con el objetivo de mejorar nuestros servicios,
               ten en cuenta que la información personal relacionada con compras, intereses y preferencias puede ser utilizada por DOMESTIKA
               con fines analíticos, caracterización del perfil del usuario, estudios de marketing, encuestas de calidad y para mejorar la
               interacción con nuestros clientes.
               <br />
               <br />
               Si no deseas recibir algunos tipos de comunicaciones que enviamos por e-mail, accede a la sección "Notificaciones", en
               "Editar perfil", para gestionar tus preferencias.
               <br />
               <br />
               Asimismo, podrás cancelar tus notificaciones siguiendo las instrucciones que aparecen en cada notificación que recibas.
            </TextStyled>

            <SubtitleStyled>6. Período de retención de datos</SubtitleStyled>
            <TextStyled>
               Retendremos tus datos personales mientras tengamos una relación contractual válida y, tras esa vigencia, durante el período
               determinado por las obligaciones derivadas del tratamiento de los datos o según establezca la ley.
            </TextStyled>

            <SubtitleStyled>7. Destinatarios de los datos</SubtitleStyled>
            <TextStyled>
               Para cumplir los objetivos indicados en esta Política de Privacidad, podría ser necesario proporcionar o revelar tus datos
               personales a terceros debido a las siguientes razones:
               <br />
               <br />
               Traspaso de negocio: relacionado con cualquier reorganización, reestructuración, fusión o venta, o cualquier otro traspaso de
               activos, incluido el personal, siempre que la parte receptora acepte procesar tus datos de acuerdo con nuestra Política de
               Privacidad.
               <br />
               <br />
               Prestadores de servicios: para prestar servicios en nuestro nombre o para ayudarnos a prestar nuestros servicios. Por
               ejemplo, contratamos proveedores para realizar servicios de marketing, publicidad, comunicación, infraestructuras y servicios
               de TI, para personalizar y mejorar nuestro servicio, para procesar las transacciones con tarjetas de crédito u otros métodos
               de pago, para el servicio de atención al cliente, para cobrar deudas, analizar y mejorar los datos (tales como datos
               relacionados con la interacción de los usuarios con nuestros servicios), y para procesar y gestionar encuestas de
               satisfacción. Con el objetivo de ser eficientes, estos socios y proveedores pueden encontrarse en EE. UU. o en otros países o
               territorios situados fuera del Espacio Económico Europeo y podrían no prestar servicios de protección de datos comparables a
               los de tu país o a los de la Unión Europea.
               <br />
               <br />
               Al aceptar nuestra Política de Privacidad, nos autorizas de manera específica a procesar e informar de tus datos personales a
               los socios mencionados y a revelar tus datos personales a los proveedores como procesadores situados fuera del Espacio
               Económico Europeo para los fines descritos en el presente documento y ofrecer un servicio completo. Cuando revelamos
               información personal al intercambiar datos con países situados fuera del Espacio Económico Europeo y otras regiones con leyes
               de protección de datos, nos aseguramos de que la información se transfiere en cumplimiento de esta Política de Privacidad y
               las leyes de protección de datos vigentes.
            </TextStyled>

            <SubtitleStyled>8. Derechos de protección de datos</SubtitleStyled>
            <TextStyled>
               Como Controlador de datos, nos comprometemos a respetar la naturaleza confidencial de tus datos personales y garantizamos el
               completo ejercicio de estos derechos. En todo momento, podrás ejercer los siguientes derechos:
               <br />
               <br />
               Derecho al acceso. Tienes derecho a confirmar si estamos procesando tus datos personales y, si lo estamos, tienes derecho a
               obtener una copia de los datos y de la información relacionada con el procesamiento.
               <br />
               <br />
               Derecho de modificación. Tienes derecho a corregir errores, a modificar datos incompletos o erróneos y a garantizar la
               autenticidad de la información procesada.
               <br />
               <br />
               Derecho a eliminar. Tienes derecho a solicitar la eliminación de tus datos personales sin un retraso injustificado, en el
               caso de que hayan sido procesados de manera errónea o si el fin para el que han sido procesados o recopilados ha dejado de
               existir.
               <br />
               <br />
               Derecho a limitar el procesamiento. Tienes derecho a solicitar la suspensión del procesamiento de tu información si es ilegal
               o si la exactitud de los datos es cuestionada.
               <br />
               <br />
               Derecho de oposición. Tienes derecho a oponerte al procesamiento de tus datos cuando han sido utilizados con fines de
               marketing directo o cuando el procesamiento deba finalizar debido a un problema personal, excepto cuando haya legítimo
               interés o sea necesario para el ejercicio o la defensa de acciones.
               <br />
               <br />
               Derecho a no ser sometido a decisiones personalizadas. Tienes derecho a no ser sometido a una decisión basada únicamente en
               el procesamiento automático de tus datos, incluida la caracterización del perfil, con efectos legales vinculantes o que te
               afecten, excepto cuando sea necesario para la ejecución de un contrato, de acuerdo con la ley, o si lo has autorizado de
               forma expresa.
               <br />
               <br />
               Para poder ejercer estos derechos, envía un e-mail a: dataprotection@domestika.org indicando tu (i) identidad con el nombre
               completo y la dirección de e-mail utilizada para registrarte o realizar compras en Domestika, un documento identificativo
               para comprobar tu identidad y (ii) el derecho o los derechos que estás ejerciendo.
               <br />
               <br />
               También puedes visitar la agencia que se encarga de supervisar la protección de datos en tu país para registrar una
               reclamación o solicitar la protección de tus derechos, si lo consideras necesario.
               <br />
               <br />
               El ejercicio de tales derechos es gratuito, excepto cuando las reclamaciones fueran deliberadamente infundadas o excesivas,
               en cuyo caso el sujeto tendrá que pagar las costas del proceso.
               <br />
               <br />
               Domestika cumple con el Escudo de Privacidad UE-EE.UU., conforme a lo dispuesto por el Departamento de Comercio de EE. UU.
               para regular la recopilación, el uso y la retención de información personal transferida por la Unión Europea a los Estados
               Unidos. Domestika ha certificado al Departamento de Comercio que se adhiere a los Principios del Escudo de Privacidad. Si
               hubiera algún conflicto entre los términos de esta Política de Privacidad y los Principios del Escudo de Privacidad,
               prevalecerán los Principios del Escudo de Privacidad. Para obtener más información sobre el programa del Escudo de
               Privacidad, puedes visitar https://www.privacyshield.gov/.
            </TextStyled>

            <SubtitleStyled>9. Información sobre cookies</SubtitleStyled>
            <TextStyled>
               Utilizamos cookies, pequeños archivos con información relativa a tu navegación en esta Plataforma, principalmente para
               posibilitar una mejor experiencia del usuario. Por favor, lee nuestra Política de cookies para obtener más información sobre
               las cookies que utilizamos, su finalidad y otra información de utilidad.
            </TextStyled>

            <SubtitleStyled>10. Requisitos</SubtitleStyled>
            <TextStyled>
               En cumplimiento de los Principios del Escudo de Privacidad, Domestika se compromete a resolver las reclamaciones relativas a
               la recopilación o al uso de tu información personal. Los usuarios de la Unión Europea con consultas o reclamaciones relativas
               a la política del Escudo de Privacidad deberán ponerse en contacto con Domestika en primer lugar:
               dataprotection@domestika.org
            </TextStyled>

            <SubtitleStyled>11. Cambios</SubtitleStyled>
            <TextStyled>
               Actualizaremos esta Política de Privacidad ocasionalmente y de acuerdo con las modificaciones legales, regulatorias u
               operativas. Te notificaremos estos cambios (incluida la fecha de vigencia) según las exigencias legales.
               <br />
               <br />
               Publicado el 28 de mayo de 2019
            </TextStyled>
         </>
      </Modal>
   );
}

const TitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 200;
   font-size: 1.7em;
   margin-top: 3em;

   @media screen and (max-width: 1600px) {
      font-size: 1.4em;
   }
`;

const SubtitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 500;
   font-size: 1.1em;
   margin-top: 2em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

const TextStyled = styled.p`
   font-size: 1em;
   color: grey;
   margin-top: 0.5em;
   font-weight: 300;
   text-align: justify;

   @media screen and (max-width: 1600px) {
      font-size: 0.8em;
   }
`;
